import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-vehicle-new',
  templateUrl: './vehicle-new.component.html',
  styleUrls: ['./vehicle-new.component.scss']
})
export class VehicleNewComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
